
import React, { useEffect } from 'react';
import { setTitle } from '../../shared/services/general/general-service';
import Footer from '../../components/footer/footer';

export default function ContactUs () {
	useEffect(() => {
		setTitle('تماس با ما');
	}, []);

	return (<>
		<div className="d-flex flex-column container" style={{maxWidth: '1440px', width: '100%', margin: '30px auto' }}>
			<br />
			<br />
			<div className="max-width-menu section-title clearfix"><h1>تماس با ما</h1></div>
			<br />
			<div className="text-center">
				<p>در صورت داشتن مشکل می توانید از طریق ایمیل زیر با ما در ارتباط باشید:
					<br />
					<br />
					info@bebin.com
					<br /><br />
					ساعت پاسخ به ایمیل ها شنبه تا چهارشنبه از ساعت 9 الی 18</p>
			</div>
		</div>
		<Footer></Footer>
	</>);
}
